import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { ScheduleCardHeader } from 'legacy-modules/sales/activity/style';
import { CardSection, FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsActivityTable from './addons-activity';
import GuestActivityDetailTable from './guest-activity-detail';

interface Props {
  refund?: RefundModel;
}

export default function ActivitySaleSection(props: Props) {
  const { control } = useFormContext();
  const name = 'activitySales';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      {fields.map((field, index) => {
        return (
          <>
            <Separator gap={24} />
            <CardSection key={field.customId}>
              <FullContainer>
                <ScheduleCardHeader>
                  <Text variant="HeadingXSmall">
                    {t('common:other_sale_detail')} {index + 1}
                  </Text>
                </ScheduleCardHeader>

                <GuestActivityDetailTable
                  parentIndex={index}
                  refund={props.refund}
                />
                <AddonsActivityTable
                  parentIndex={index}
                  refund={props.refund}
                />
              </FullContainer>
            </CardSection>
          </>
        );
      })}
    </>
  );
}
